/**
 * The words of the profile's login-phone section (ARCH-055). Plain Sie-form;
 * names the target of every code, since two codes arrive one after the other,
 * and never lets a phone-only user change their only way in without warning.
 */
export const loginPhoneCopy = {
  label: "Mobilnummer für die Anmeldung",
  hasLogin: "Mit dieser Nummer melden Sie sich per SMS-Code an.",
  noLogin:
    "Hinterlegen Sie eine Mobilnummer, um sich auch per SMS-Code anzumelden. Die Anmeldung per E-Mail bleibt erhalten.",
  noFactor: (support: string) =>
    `Eine Mobilnummer für die Anmeldung können wir hier erst hinterlegen, wenn Ihre E-Mail-Adresse bestätigt ist. Schreiben Sie uns an ${support}, wir helfen Ihnen weiter.`,
  change: "Nummer ändern",
  add: "Mobilnummer hinzufügen",
  cancel: "Abbrechen",
  newNumberLabel: "Neue Mobilnummer",
  mobileHint: "Für die Anmeldung per SMS brauchen wir eine Mobilnummer.",
  replaceWarning: (ending: string) =>
    `Danach melden Sie sich mit der neuen Nummer an. Mit der bisherigen Nummer (endet auf ${ending}) gelangen Sie nicht mehr in dieses Konto, und auf anderen Geräten werden Sie abgemeldet.`,
  phoneOnlyWarning:
    "Ihre Mobilnummer ist Ihr einziger Zugang zu diesem Konto. Bitte prüfen Sie die neue Nummer genau, bevor Sie fortfahren.",
  sendCode: "Code senden",
  stepUpPhone: (ending: string) =>
    `Zur Sicherheit bestätigen Sie die Änderung zuerst mit dem Code, den wir an Ihre bisherige Nummer (endet auf ${ending}) gesendet haben.`,
  stepUpEmail: (email: string) =>
    `Zur Sicherheit bestätigen Sie die Änderung zuerst mit dem Code, den wir an ${email} gesendet haben.`,
  lostPhone: (support: string) =>
    `Kein Zugriff mehr auf Ihre bisherige Nummer? Schreiben Sie uns an ${support} – wir helfen Ihnen weiter.`,
  newCode: (ending: string) =>
    `Geben Sie jetzt den Code ein, den wir an die neue Nummer (endet auf ${ending}) gesendet haben.`,
  codeLabel: "Code aus der Nachricht",
  verify: "Code prüfen",
  resend: "Neuen Code anfordern",
  restart: "Neu beginnen",
  doneReplaced: (ending: string) =>
    `Gespeichert. Sie melden sich ab jetzt mit der Nummer an, die auf ${ending} endet. Auf anderen Geräten werden Sie abgemeldet.`,
  doneUnchanged: (ending: string) =>
    `Gespeichert. Sie melden sich mit der Nummer an, die auf ${ending} endet.`,
  doneAdded: (ending: string) =>
    `Gespeichert. Sie können sich ab jetzt auch mit der Nummer anmelden, die auf ${ending} endet.`,
  mailOnTheWay: " Eine Bestätigung ist per E-Mail unterwegs.",
  callback: (phone: string) =>
    `Rückrufnummer: ${phone} (nur für Rückfragen). Ändern? Schreiben Sie uns kurz.`,
  unavailable:
    "Die SMS-Bestätigung ist gerade nicht verfügbar. Bitte versuchen Sie es später erneut.",
} as const;
